import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../common/Card';
import { CreditCard, TrendingUp } from 'lucide-react';

export const QuickStats = ({ subscriptions, totalSpent, isLoading, currency, currencySymbol }) => (
    <Card>
        <CardHeader>
            <CardTitle>Quick Stats</CardTitle>
        </CardHeader>
        <CardContent>
            <div className="grid grid-cols-2 gap-4">
                <div className="flex items-center">
                    <CreditCard className="h-5 w-5 mr-2 text-blue-500" />
                    <div>
                        <div className="text-sm font-medium text-gray-500">Active Subs</div>
                        {isLoading ? (
                            <div className="h-8 w-16 bg-gray-200 animate-pulse rounded" />
                        ) : (
                            <div className="text-2xl font-bold">
                                {subscriptions.filter(sub => sub.status === 'active').length}
                            </div>
                        )}
                    </div>
                </div>
                <div className="flex items-center">
                    <TrendingUp className="h-5 w-5 mr-2 text-green-500" />
                    <div>
                        <div className="text-sm font-medium text-gray-500">Avg. Cost</div>
                        {isLoading ? (
                            <div className="h-8 w-24 bg-gray-200 animate-pulse rounded" />
                        ) : (
                            <div className="text-2xl font-bold">
                                {currencySymbol}
                                {subscriptions.length ? 
                                    (totalSpent / subscriptions.filter(sub => sub.status === 'active').length).toFixed(2) 
                                    : '0.00'}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </CardContent>
    </Card>
);